import { useRoutes } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import axios from "axios"; // Import Axios for interceptor configuration

import { MatxTheme } from "./components"; // Custom Material-UI theme
import { AuthProvider } from "./contexts/JWTAuthContext"; // Authentication context
import SettingsProvider from "./contexts/SettingsContext"; // Settings context
import routes from "./routes"; // Application routes configuration
import "../fake-db"; // Fake server for mocking API responses (development only)

// Axios Interceptor Configuration
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("jwtToken"); // Retrieve token from localStorage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`; // Add token to Authorization header
    }
    return config;
  },
  (error) => {
    return Promise.reject(error); // Handle request errors
  }
);

export default function App() {
  // Generate routes using `useRoutes`
  const content = useRoutes(routes);

  return (
    // SettingsProvider for app-wide settings (e.g., theme, layout)
    <SettingsProvider>
      {/* AuthProvider for managing user authentication */}
      <AuthProvider>
        {/* MatxTheme wraps Material-UI theme and customizations */}
        <MatxTheme>
          {/* CssBaseline for consistent styling and reset */}
          <CssBaseline />
          {/* Render application content */}
          {content}
        </MatxTheme>
      </AuthProvider>
    </SettingsProvider>
  );
}






// import { useRoutes } from "react-router-dom";
// import CssBaseline from "@mui/material/CssBaseline";

// import { MatxTheme } from "./components";
// // ALL CONTEXTS
// import { AuthProvider } from "./contexts/JWTAuthContext";
// import SettingsProvider from "./contexts/SettingsContext";
// // ROUTES
// import routes from "./routes";
// // FAKE SERVER
// import "../fake-db";

// export default function App() {
//   const content = useRoutes(routes);

//   return (
//     <SettingsProvider>
//       <AuthProvider>
//         <MatxTheme>
//           <CssBaseline />
//           {content}
//         </MatxTheme>
//       </AuthProvider>
//     </SettingsProvider>
//   );
// }




// import { useRoutes } from "react-router-dom";
// import CssBaseline from "@mui/material/CssBaseline";

// import { MatxTheme } from "./components";
// // ALL CONTEXTS
// import { AuthProvider } from "./contexts/JWTAuthContext";
// import SettingsProvider from "./contexts/SettingsContext";
// // ROUTES
// import routes from "./routes";
// // FAKE SERVER
// import "../fake-db";

// export default function App() {
//   const content = useRoutes(routes);

//   return (
//     <SettingsProvider>
//       <AuthProvider>
//         <MatxTheme>
//           <CssBaseline />
//           {content}
//         </MatxTheme>
//       </AuthProvider>
//     </SettingsProvider>
//   );
// }
